import { MobileDevelopmentPage } from './MobileDevelopmentPage';

export default MobileDevelopmentPage;
